export const activityData = [

    {
        title: "Go for a walk",
        description: 'These boots were made for walking, and that\'s just what they\'ll do. Okay maybe don\'t wear boots.',
        type: "outdoor",
        id: "1",
        image: "./Go_for_a_walk.jpeg"
    },
    {
        title: "Write in a journal",
        description: 'Write all the things down. But make sure you hide it real well when you\'re done.',
        type: "indoor",
        id: "2",
        image: "./Write_in_a_journal.jpeg"
    },
    {
        title: "Go for a run",
        description: 'Bust out the Asics, run like Phoebe. It\'ll feel great.',
        type: "outdoor",
        id: "3",
        image: "./Go_for_a_run.jpeg"
    },
    {
        title: "Make a phone call",
        description: 'You\'ll be hoping they don\'t answer, but you won\'t regret when they do. Promise.',
        type: "??",
        id: "4",
        image: "./Make_a_phone_call.jpeg"
    },
    {
        title: "Go on a bike ride",
        description: 'Don\'t forget your helmet!!!! Safety first.',
        type: "outdoor",
        id: "5",
        image: "./Go_on_a_bike_ride.jpeg"
    },
    {
        title: "Send a text",
        description: 'Remember that text from Alex you read and mentally replied to a week ago, but didn\'t actually do it in real life? Just tell her you were asleep. Works every time.',
        type: "",
        id: "6",
        image: "./Send_a_text.jpeg"
    },
    {
        title: "Socialize",
        description: 'You are so brave. I want to be like you when I grow up.',
        type: "",
        id: "7",
        image: "./Socialize.png"
    },
    {
        title: "Meditate",
        description: 'Breathe in, breathe out. Repeat.',
        type: "",
        id: "8",
        image: "./Meditate.jpeg"
    },
    {
        title: "Paint",
        description: 'We can\'t all be Leonardo da Vincis\', but we can be Picassos\'.',
        type: "",
        id: "9",
        image: "./Paint.jpeg"
    },
    {
        title: "Read a book",
        description: 'So what if it\'s 50 Shades of Grey? Enjoy every cringey sentence.',
        type: "",
        id: "10",
        image: "./Read_a_book.jpeg"
    },
    {
        title: "Tend to the garden",
        description: 'Remember that plant that somehow survived the winter? Go show it some love.',
        type: "",
        id: "11",
        image: "./Tend_to_the_garden.jpeg"
    },
    {
        title: "Pet a dog",
        description: 'Add this to every day of your calendar. Do it. Trust me.',
        type: "",
        id: "12",
        image: "./Pet_a_dog.jpeg"
    }
    
];
